export default "__VITE_ASSET__CfiNFBqm__"